export default "__VITE_ASSET__BA3Ag3mB__"